import { render } from "./thankyou-outlet.vue?vue&type=template&id=9bfdb774&scoped=true"
import script from "./thankyou-outlet.vue?vue&type=script&lang=js"
export * from "./thankyou-outlet.vue?vue&type=script&lang=js"

import "./thankyou-outlet.vue?vue&type=style&index=0&id=9bfdb774&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bfdb774"]])

export default __exports__